<div class="top-page sidebar-collapse">
<app-l-header></app-l-header>
<!-- End Navbar -->
<!--<div class="wrapper wrapper-full-page">
  <div class="page-header login-page header-filter" filter-color="black" style="background-image:
  url('../../../assets/images/bespoke.jpg'); background-size: cover; background-position: top center;">
    &lt;!&ndash;   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " &ndash;&gt;
    <div class="container">
      <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
          <div class="card card-login card-hidden">
            <div class="card-header card-header-warning text-center">
              <h4 class="card-title">LOGIN</h4>
              <div class="social-line">
               Login to your account
              </div>
            </div>
            <form novalidate  #loginForm="ngForm" (ngSubmit)="loginProcess()">
              <div class="card-body">
                &lt;!&ndash;<span class="font-weight-bold red" >{{ errorMessage | titlecase }}</span>&ndash;&gt;
                <div class="bmd-form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">email</i>
                      </span>
                    </div>
                    <input type="email" class="form-control" placeholder="Email"
                           #email="ngModel" minlength="4" id="email"
                           [(ngModel)]="credentials.email" [ngModelOptions]="{standalone: true}" required>
                  </div>
                </div>
              <div class="bmd-form-group">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">lock_outline</i>
                      </span>
                    </div>
                    <input type="password" class="form-control " placeholder="Password" #password="ngModel" minlength="8" id="password"
                           [(ngModel)]="credentials.password" [ngModelOptions]="{standalone: true}" required>
                  </div>
                </div>
            </div>
            <div class="card-footer justify-content-center">
              <button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">
                <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>LOGIN TO ACCOUNT</button>
            </div>

              <div class="text-center" style="font-size: 13px;">
                <p class="px-2"><a href="javascript:void(0)" [routerLink]="['/forgot-password']" class="text-rose">Forgot password?</a></p>
              </div>
            </form>
          </div>
      </div>
    </div>
  </div>
</div>-->

  <div class="wrapper wrapper-full-page">
    <div class="page-header login-page header-filter" filter-color="black" style="background-image:
  url('../../../assets/img/collegedreams.jpg'); background-size: cover; background-position: top center;">
      <!--   you can change the color of the filter page using: data-color="blue | purple | green | orange | red | rose " -->
    <div class="container end">
       <div class="row login-cards">
        <div class="col">
          <div class="d-flex align-items-start flex-column" style="height: 200px;">
            <div class="mb-5 p-2"></div>
            <div class="mb-5 p-2"></div>
            <div class="mb-5 p-2"></div>
            <div class="p-2 pg1 text-center">We’re glad to have you back!!!</div>
            <div class="p-2 pg2 text-center">Fill the form to Login</div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 ml-auto mr-auto">
          <div class="card card-login card-hidden">
            <div class="card-header text-center">
              <h4 class="card-title">LOGIN</h4>
              <!--<div class="social-line">
                Login to your account
              </div>-->
            </div>
            <form novalidate  #loginForm="ngForm" (ngSubmit)="loginProcess()">
              <div class="card-body">
                <!--Select School-->
                <!--<div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">school</i>
                      </span>
                    </div>
                    <ng-select [items]="schools" class="ng-select-form"
                               id="school" #schoolList
                               [searchable]="false"
                               [notFoundText]="'No Matching School Name'"
                               placeholder="Select School"
                               bindLabel="schoolName"
                               bindValue="schoolName"
                               [(ngModel)]="credentials.school"
                               [ngModelOptions]="{standalone: true}" style="cursor:pointer;">
                      <ng-template ng-header-tmp>
                        <input style="width: 100%; line-height: 24px" type="text" placeholder="Search Schools..."
                               (input)="schoolList.filter($event.target.value)"/>
                      </ng-template>
                    </ng-select>

                    &lt;!&ndash;<select class="form-control custom-select"
                            #school="ngModel" id="school"
                            [(ngModel)]="credentials.schools"
                            [ngModelOptions]="{standalone: true}">
                      <option value=""> Select School</option>
                      <option value="{{school.id}}" *ngFor="let school of schools">
                        {{school.name}}
                      </option>
                    </select>
                    <div *ngIf="isValidated && school.errors?.required" class="alert alert-danger mt-2">
                      Select a School from the Dropdown
                    </div>
                  </div>
                  <div class="fa-div">
                    <i class="fa fa-sort fa-1x" aria-hidden="true"></i>
                  </div>&ndash;&gt;
                  </div>
                </div>-->
                <!--Email-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">email</i>
                      </span>
                    </div>
                    <input type="email" class="form-control" placeholder="Email"
                           #username="ngModel" id="email"
                           [(ngModel)]="credentials.username"
                           [ngModelOptions]="{standalone: true}" required
                           autocomplete="false">
                    <!-- minlength="4"-->
                  </div>
                </div>
                <!--Password-->
                <div class="bmd-form-group pb-3">
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="material-icons">lock_outline</i>
                      </span>
                    </div>
                    <input [type]="fieldTextType ? 'text' : 'password'"
                           class="form-control" maxlength="6" placeholder="Password"
                           #password="ngModel"
                           id="password" [(ngModel)]="credentials.password" [ngModelOptions]="{standalone: true}" required autocomplete="false">
                    <div class="input-group-append">
                      <i class="fa input-group-text"
                         [ngClass]="{
                              'fa-eye-slash': !fieldTextType,
                              'fa-eye': fieldTextType
                            }"
                         (click)="toggleFieldTextType()"
                         style="
                            border-bottom: 1px solid #ccc;
                            height: 44px;">
                      </i>
                    </div>
                    <!-- minlength="8"-->
                  </div>
                </div>
              </div>
              <div class="card-footer justify-content-center">
                <button type="submit" class="login-button mt-2">
                  <!--<button type="submit" class="btn btn-warning btn-lg" [disabled]="password.errors || email.errors || loading">-->
                  <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
                  LOGIN TO ACCOUNT
                </button>
              </div>

              <!--<div class="text-center" style="font-size: 13px;">
                <p class="text-center px-2" style="padding: 10px 15px; border-radius: 8px; border: 1px solid #ff9800;
                box-shadow:
                 0 2px 2px 0 rgb(255 152 0 / 14%), 0 3px 1px -2px rgb(255 152 0 / 20%), 0 1px 5px 0 rgb(255 152 0 / 12%); margin:
                12px 61% 6px 5px;">
                  <a href="javascript:void(0)" [routerLink]="['/forgot-password']" class="text-rose">
                    Forgot Password?
                  </a>
                </p>
              </div>-->
              <div style="font-size: 13px;">
                <p class="text-center px-2">
                  <a href="javascript:void(0)" [routerLink]="['/forgot-password']"
                                          class="text-rose">
                    Forgot Password?
                  </a>
                </p>
              </div>
              <div  style="font-size: 13px;">
                <p class="text-center mx-6 mt-3">
                  Don’t have an account yet?
                  <a href="javascript:void(0)" [routerLink]="['/sign-up']"
                     class="text-rose">
                    Sign up
                  </a>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  <footer class="footer">
    <app-l-footer></app-l-footer>
  </footer>
  </div>
</div>
<!--

<div class="page-header clear-filter" filter-color="orange">
    <div class="page-header-image" style="background-image:url(../../../assets/img/login.jpg)"></div>
    <div class="content">
      <div class="container">
        <div class="col-md-4 ml-auto mr-auto">
          <div class="card card-login card-plain">
            <form novalidate  #loginForm="ngForm" (ngSubmit)="loginProcess()">
              <div class="card-header text-center">
                <div class="logo-container">
                  <img src="../../../assets/images/MwareCollegeDreamsWeb.png" alt="Mware College Dreams Web LOGO"
                       width="300px">
                </div>
              </div>
              <div class="card-body">
                <div class="input-group no-border input-lg">
                  <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="now-ui-icons users_circle-08"></i>
                      </span>
                  </div>
                  <input type="email" class="form-control" placeholder="Email"
                         #email="ngModel" minlength="4" id="email"
                         [(ngModel)]="credentials.email" [ngModelOptions]="{standalone: true}" required>
                </div>
                <div class="input-group no-border input-lg">
                  <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                      </span>
                  </div>
                  <input type="password" class="form-control " placeholder="Password" #password="ngModel" minlength="8" id="password"
                         [(ngModel)]="credentials.password" [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="card-footer text-center">
                <a type="submit"  class="btn btn-primary btn-round btn-lg btn-block" [disabled]="password.errors ||
                email.errors || loading">
                  <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>LOGIN TO ACCOUNT
                </a>
                <div class="pull-left">
                  <h6>
                    <a [routerLink]="['/forgot-password']" class="link">
                      Forgot Password
                    </a>
                  </h6>
                </div>
                <div class="pull-right">
                  <h6>
                    <a [routerLink]="['/']" class="link">Need Help?</a>
                  </h6>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

-->
</div>
